//include 9
jQuery(function(){
    //*
    $('.map-expander .ausklappen').click(function (e) {
        $(this).toggleClass('active');
        // var id = $(this).attr('data-target');
        var maprow = $(this).parent().parent().siblings('.row-map:first');
        maprow.toggleClass('active');
        var label = $(this).siblings('label:first');
        label.toggleClass('active');

        maprow.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
              function (event) {
                  if (window.ppcartoMedium && window.ppcartoMedium.$refs && window.ppcartoMedium.$refs.ppcm) {
                      //setTimeout(function () {
                          window.ppcartoMedium.$refs.ppcm.resize();
                      //}, 200);                      
                  }
              });

        if (label) {
            var active_text = label.attr('data-active');
            var text = label.html();
            label.html(active_text);
            label.attr('data-active', text);

            $(this).attr("title", active_text);
        }

        // refreshing map to center it again
        //var map = $(this).parent().parent().parent().find('iframe')[0];
        //map.src = map.src;


    });
    //*/
});